import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';

/**
 * One axis that can be fixed or free, shown as a boxed toggle button: the axis
 * letter, a lock and the word "Fixed" or "Free". Fixed uses the error tone,
 * because a fixed axis is a constraint.
 */
@Component({
  selector: 'app-axis-lock',
  templateUrl: './axis-lock.component.html',
  styleUrl: './axis-lock.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AxisLockComponent {
  readonly axis = input.required<string>();
  readonly fixed = model(false);
  readonly disabled = input(false);

  /** A stable name; the fixed state is carried by aria-pressed, so it is announced once. */
  readonly accessibleName = computed(() => `${this.axis()} axis`);

  toggle(): void {
    if (this.disabled()) return;
    this.fixed.set(!this.fixed());
  }
}
